import { CLASSES } from '../data/classes.js';
import { getItem } from '../data/items.js';
/**
 * What a new character is handed: the two templates its class names
 * (CADRAGE: "une arme de départ" per class). The class data is the source, and
 * `starting-kit.test.ts` holds it to what a kit must be — one weapon, one
 * off-hand, common, wearable at level 1 by that class.
 */
export function startingKit(classId) {
    return CLASSES[classId].startingKit.map((id) => {
        const template = getItem(id);
        if (template === undefined)
            throw new Error(`Class ${classId} starts with unknown item ${id}`);
        return template;
    });
}
//# sourceMappingURL=starting-kit.js.map